import { createGlobalStyle } from 'styled-components';
import { theme } from '@frameio/vapor';

const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
    width: 100%;
  }

  body {
    background: ${theme.colors.background.base};
    width: 100%;
    height: 100%;
  }

  #__next {
    width: 100%;
    height: 100%;
  }

  a {
    text-decoration: none;
  }
`;

/** the vapor 4 global styles combined with the web app global styles */
export function WebAppGlobalStyle() {
  return (
    <>
      <GlobalStyle />
    </>
  );
}
